import iosAutocaptureConfiguration from "../../../../contents/docs/libraries/ios/_snippets/autocapture.mdx";
import * as React from 'react';
export default {
  iosAutocaptureConfiguration,
  React
};